import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from "../buttons/login-button";
import { TermsOfUseDisclaimer } from "../common/TermsOfUseDisclaimer";

interface CTASectionProps {
  finalCtaRef: React.RefObject<HTMLElement>;
  handleSignUp: (e?: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
}

export const CTASection: React.FC<CTASectionProps> = ({ finalCtaRef, handleSignUp }) => {
  const { isAuthenticated } = useAuth0();

  return (
    <section className="final-cta-section" ref={finalCtaRef}>
      <div className="cta-content">
        <h3>Ready to get your time back?</h3>
        <p>
          Join the growing community of Australian teachers already transforming their workload with Gymea Edu.
        </p>
        <div className="final-cta-buttons">
          {!isAuthenticated ? (
            <>
              <div className="final-buttons">
                <button onClick={handleSignUp} className="cta-button">Get Started</button>
                <LoginButton />
              </div>
              <TermsOfUseDisclaimer />
            </>
          ) : (
            <a href="/dashboard" className="cta-button">Continue to Dashboard</a>
          )}
        </div>
      </div>
    </section>
  );
};